module.exports = __webpack_public_path__ + "img/rail-chain-signal-metal.19582f18.png";